// todo: consolidate this form and the one in react-sso-landing



import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { loginSetFlowStageWatcher, loginWatcher } from "../../redux/actions/loginactioncreators";
import { FormattedMessage } from "react-intl";
import flowStages from "../../flowStages";
import { NewFADVLoginForm } from "../login/NewFADVLoginForm";
import { emailValidator } from "../login/EmailValidator";
import { EmailEntry } from "../login/EmailEntry";



export function ChangeEmailAddress() {
  const dispatch = useDispatch();
  const challenge = useSelector(state => state.loginForm.challenge);
  const username = useSelector(state => state.loginForm.username);
  const oldEmail = useSelector(state => state.loginForm.userInfo?.UserAttributes?.email)
  const [hasBeenSubmitted, setHasBeenSubmitted] = React.useState(false);

  const handleSubmit = (formData, errors) => {
    setHasBeenSubmitted(true);
    if (errors && Object.keys(errors).length > 0) {
      // Do not dispatch if there are errors
      return;
    }
    dispatch(loginWatcher({
      flowStage: flowStages.CHANGE_EMAIL_ADDRESS,
      username: username,
      challengeResponse: {
        session: challenge.session,
        challengeName: challenge.challengeName,
        challengeParameters: {
          USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
          NEW_EMAIL: formData.emailAddress,
        }
      }
    }));
  };

  const handleSkip = () => {
    dispatch(loginSetFlowStageWatcher({
      flowStage: flowStages.SKIP_EMAIL_NOT_VERIFIED,
    }));
  };

  return (
    <NewFADVLoginForm
      onSubmit={handleSubmit}
      showErrors={hasBeenSubmitted}
      requiredFields={["emailAddress"]}
      headerText="Change email" //Todo: localize
      submitButtonText={<FormattedMessage id="login.changeEmailSubmit" defaultMessage="Submit" description="Submit button for changing email address" />}
      secondaryButtonText={<FormattedMessage id="login.skipEmailSubmit" defaultMessage="Skip This Step" description="Button to skip changing email address" />}
      secondaryButtonHandler={handleSkip}
      secondaryButtonId="skip"
    >
      <div className="text-base">
        <FormattedMessage
          id="login.changeEmailBlurb"
          defaultMessage="Your email address is in use by a different login. Please change your email address. A confirmation email will be sent to the new address with a code."
          description="Blurb explaining why user must change email address"
        />
      </div>
      <EmailEntry
        id="emailAddress"
        name="emailAddress"
        autoFocus={true}
        match={oldEmail}
        validator={emailValidator}
      />
    </NewFADVLoginForm>
  );
}
